import React from 'react';
import { Content, Button, Text, Radio, Pane } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { ValueCache } from '@leverege/value-cache';
import merge from 'deepmerge';
import { GlobalState } from '@leverege/ui-redux';
import { Users } from '@leverege/api-redux';
import I18N from '@leverege/i18n';
import { getMethodsFor } from "../methods/Methods.js";
import LoginModal from "./LoginModal.js";
import OneTimeCodes from "./OneTimeCodes.js";
import Success from "./Success.js";
const {
  t
} = I18N.ns('login.twoFactor.Enable2FAFlow');
export default class Enable2FAFlow extends React.Component {
  constructor(props) {
    super(props);
    this.flowCache = new ValueCache();
    const {
      method
    } = props;
    let step = 0;
    let isSecondaryMethod = false;
    if (method) {
      isSecondaryMethod = true;
      if (method.preActivateComponent) {
        step = 1;
      } else {
        step = 2;
      }
    }
    this.state = {
      password: null,
      step,
      selectedMethod: method,
      preActivateData: null,
      confirmationData: null,
      authenticationData: null,
      oneTimeCodes: null,
      isSecondaryMethod
    };
  }
  onActivate2FAMethod = async () => {
    const {
      profile,
      onClose
    } = this.props;
    const {
      confirmationData,
      selectedMethod,
      step
    } = this.state;
    try {
      const {
        oneTimeCodes
      } = await GlobalState.dispatch(Users.activateTwoFactorMethod(profile.id, selectedMethod.type, confirmationData.code));
      if (oneTimeCodes) {
        this.setState({
          step: step + 1,
          oneTimeCodes
        });
      } else {
        onClose();
      }
    } catch (err) {
      this.setState({
        confirmationError: err.message
      });
    }
  };
  onResendCode = async () => {
    const {
      selectedMethod,
      preActivateData,
      password
    } = this.state;
    const {
      profile
    } = this.props;
    try {
      const res = await selectedMethod.onPreActivate(profile, preActivateData, password);
      this.setState({
        authenticationData: res.data,
        resentCode: true
      });
    } catch (err) {
      this.setState({
        error: err.message
      });
    }
  };
  onPreActivate2FA = async () => {
    const {
      selectedMethod,
      preActivateData,
      password,
      step
    } = this.state;
    const {
      profile
    } = this.props;
    try {
      const res = await selectedMethod.onPreActivate(profile, preActivateData, password);
      this.setState({
        step: step + 1,
        authenticationData: res.data
      });
    } catch (err) {
      this.setState({
        error: err.message
      });
    }
  };
  setPreActivateData = preActivateData => {
    this.setState({
      preActivateData
    });
  };
  setConfirmationData = confirmationData => {
    this.setState({
      confirmationData
    });
  };
  onSelectMethod = ({
    data
  }) => {
    this.setState({
      selectedMethod: data
    });
  };
  onNextStep = evt => {
    const {
      step
    } = this.state;
    this.setState({
      step: step + 1
    });
  };
  getFlow = () => {
    const {
      title,
      icon,
      onClose,
      headerVariant,
      contentVariant,
      footerVariant
    } = this.props;
    const {
      password,
      error,
      selectedMethod,
      preActivateData,
      confirmationData,
      authenticationData,
      confirmationError,
      oneTimeCodes,
      resentCode,
      isSecondaryMethod
    } = this.state;
    const PreActivateComponent = selectedMethod?.preActivateComponent;
    const ConfirmationComponent = selectedMethod?.confirmationComponent;
    const validatePreActivateData = selectedMethod?.validatePreActivateData;
    return this.flowCache.calc(props => {
      return {
        defaults: {
          header: {
            render: () => {
              return /*#__PURE__*/React.createElement(TitleBar, {
                variant: "twoStepDialogTitle|dialogTitle",
                title: title,
                icon: icon
              });
            },
            variant: headerVariant
          },
          content: {
            variant: contentVariant,
            layout: 'flex:colM'
          },
          footer: {
            variant: footerVariant,
            layout: 'flex:rowMEnd'
          }
        },
        steps: [{
          id: 'select2FAMethod',
          content: {
            render: () => {
              const {
                selectedMethod
              } = this.state;
              const {
                project2FASettings
              } = this.props;
              const twoFactorMethods = getMethodsFor(project2FASettings);
              return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
                variant: "twoStepTitle|title"
              }, t('title')), /*#__PURE__*/React.createElement(Text, null, t('subtitle')), twoFactorMethods.map(method => /*#__PURE__*/React.createElement(Pane, {
                key: method.type,
                variant: "radio"
              }, /*#__PURE__*/React.createElement(Radio, {
                labelSpace: "16px",
                containerVariant: "radio",
                variant: "twoFactorMethodRadio",
                label: /*#__PURE__*/React.createElement(Text, {
                  variant: "subtitle"
                }, method.name),
                help: method.description,
                onChange: this.onSelectMethod,
                on: true,
                value: selectedMethod?.type === method.type,
                eventData: method
              }))));
            }
          },
          footer: {
            render: () => {
              return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
                variant: "primaryCancel",
                onClick: onClose
              }, t('cancel')), /*#__PURE__*/React.createElement(Button, {
                variant: "primary",
                onClick: () => {
                  const {
                    selectedMethod
                  } = this.state;
                  let {
                    step
                  } = this.state;
                  if (selectedMethod.preActivateComponent) {
                    step += 1;
                  } else {
                    step += 2;
                  }
                  this.setState({
                    step
                  });
                }
              }, t('next')));
            }
          }
        }, {
          id: 'preActivate',
          content: {
            component: PreActivateComponent,
            props: {
              setPreActivateData: this.setPreActivateData,
              preActivateData,
              ...this.props
            }
          },
          footer: {
            render: () => {
              const disabled = validatePreActivateData && !validatePreActivateData(preActivateData);
              return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
                variant: "primaryCancel",
                onClick: onClose
              }, t('cancel')), /*#__PURE__*/React.createElement(Button, {
                type: "submit",
                disabled: disabled,
                variant: "primary",
                onClick: this.onNextStep
              }, t('next')));
            }
          }
        }, {
          id: 'enterPassword',
          content: {
            component: LoginModal,
            props: {
              onChange: ({
                value
              }) => this.setState({
                password: value
              }),
              variant: 'loginWarning',
              password,
              error
            }
          },
          footer: {
            render: () => {
              return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
                variant: "primaryCancel",
                onClick: onClose
              }, t('cancel')), /*#__PURE__*/React.createElement(Button, {
                type: "submit",
                disabled: password == null || password === '',
                variant: "primary",
                onClick: this.onPreActivate2FA
              }, t('next')));
            }
          }
        }, {
          id: 'enterCode',
          content: {
            component: ConfirmationComponent,
            props: {
              method: selectedMethod,
              preActivateData,
              confirmationData,
              setConfirmationData: this.setConfirmationData,
              authenticationData,
              error: confirmationError,
              onResendCode: this.onResendCode,
              resentCode
            }
          },
          footer: {
            render: () => {
              return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
                variant: "primaryCancel",
                onClick: onClose
              }, t('cancel')), /*#__PURE__*/React.createElement(Button, {
                type: "submit",
                disabled: confirmationData?.code == null || confirmationData?.code === '',
                variant: "primary",
                onClick: this.onActivate2FAMethod
              }, isSecondaryMethod ? t('submit') : t('next')));
            }
          }
        }, {
          id: 'viewOneTimeCodes',
          content: {
            component: OneTimeCodes,
            props: {
              oneTimeCodes
            }
          },
          footer: {
            render: () => {
              return /*#__PURE__*/React.createElement(Button, {
                disabled: confirmationData?.code == null || confirmationData?.code === '',
                variant: "primary",
                onClick: this.onNextStep
              }, t('next'));
            }
          }
        }, {
          id: 'success',
          content: {
            component: Success
          },
          footer: {
            render: () => {
              return /*#__PURE__*/React.createElement(Button, {
                disabled: confirmationData?.code == null || confirmationData?.code === '',
                variant: "primary",
                onClick: onClose
              }, t('finish'));
            }
          }
        }]
      };
    }, this.props, this.state);
  };
  getStepData = () => {
    const {
      step
    } = this.state;
    const flow = this.getFlow();
    return merge(flow.defaults, flow.steps[step], {
      arrayMerge: overwriteMerge
    });
  };
  renderStep(step) {
    const stepData = this.getStepData();
    const {
      header,
      content,
      footer
    } = stepData;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Content.Header, {
      variant: header.variant,
      layout: header.layout
    }, renderStepSection(header)), /*#__PURE__*/React.createElement(Content.Area, {
      variant: content.variant,
      layout: content.layout
    }, renderStepSection(content)), /*#__PURE__*/React.createElement(Content.Footer, {
      variant: footer.variant,
      layout: footer.layout
    }, renderStepSection(footer)));
  }
  render() {
    const {
      mobile
    } = this.props;
    const {
      step
    } = this.state;
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: e => e.preventDefault()
    }, /*#__PURE__*/React.createElement(Content, {
      relative: !mobile
    }, this.renderStep(step)));
  }
}
function renderStepSection(section) {
  const {
    component: Component,
    render
  } = section;
  if (Component) {
    return /*#__PURE__*/React.createElement(Component, section.props);
  }
  if (render) {
    return render(section.props);
  }
  return null;
}
function overwriteMerge(dest, source) {
  return source;
}